import $ from 'gridstrap/lib/gs-zepto';
import analytics from 'gridstrap/lib/gs-analytics';
declare var ga;

export class GSFormField {

	//
	// Properties
	//

	root;
	input;

	get isActive()         { return this.root.hasClass('is-active'); }
	get isPopulated()      { return this.root.hasClass('is-populated'); }
	get value()            { return this.input.val().trim(); }

	get gaCategory() { return this.root.data('gsFormFieldGaCategory'); }
	get gaLabel()    { return this.root.data('gsFormFieldGaLabel'); }
	get gaActions()  { return (this.root.data('gsFormFieldGaActions') || '').split(' '); }

	set isActive(value)    { this.root.toggleClass('is-active', !!value); }
	set isPopulated(value) { this.root.toggleClass('is-populated', !!value); }
	set value(value)       { this.input.val(value.trim()); }

	//
	// Methods
	//

	focus() {
		this.input.focus();
	}

	blur() {
		this.input.blur();
	}

	track(eventAction) {
		if (!this.gaActions.includes(eventAction)) return;
		let { gaCategory: eventCategory, gaLabel: eventLabel } = this;
		analytics.event({ eventCategory, eventAction, eventLabel });
	}

	//
	// Initializations & Event Listeners
	//

	constructor(root) {
		this.root = $(root);
		this.input = this.root.find('.gs-FormField-input');

		this.input.on({
			focus:    ()  => this.isActive = true,
			blur:     evt => this.handleBlur(evt),
			keyup:    evt => this.handleKeyUp(evt),
			keypress: evt => this.handleKeyPress(evt),
			paste:    evt => this.handlePaste(evt)
		});

	}

	gsOnDestroy() {
		this.input.off();
	}

	private handleBlur(evt: KeyboardEvent) {
		this.isActive = false;
		this.isPopulated = (this.value !== '');
		this.value = this.value;
	}

	private handleKeyPress(evt: KeyboardEvent) {
		// Ignore arrow keys and other non-character key presses
		const keyPressed = String.fromCharCode(evt.which || evt.keyCode);
		const keyString = keyPressed.replace(/[^\x20-\x7E]+/g, '');
		if (keyString == '') return;

		this.isPopulated = true;
		this.track('keypress');
		this.input.off('keypress');
	}

	private handleKeyUp(evt: KeyboardEvent) {
		const keyCode = evt.which || evt.keyCode;
		if (keyCode === 27 /* esc */) this.input.blur();
	}

	private handlePaste(evt) {
		// It takes a moment for the pasted content to show up...
		setTimeout(() => { this.isPopulated = (this.value !== ''); }, 10);
		this.track('keypress');
	}

}
